module.exports = __webpack_public_path__ + "f3903189bb21ef58d80ab9f0accae770.svg";